import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { MyErrorStateMatcher, RequireMatch } from "src/app/utils/requireMatch";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
  styles: ["::ng-deep .mat-input-underline {display: none;}"],
})
export class MovimientosModal implements OnInit {
  @ViewChild("polizaInput", { static: false })
  public polizaInput: ElementRef;

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();

  list: any[] = [];
  realData: any[] = [];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  public columns: ListColumn[] = [
    {
      name: "Material",
      property: "MaterialDesc",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Cant",
      property: "Cant",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Razon",
      property: "Razon",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Factura",
      property: "NoFactura",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  public actions: any[] = [
    {
      desc: "Eliminar",
      action: "delete",
      color: "text-red-600",
      icon: "far fa-trash-alt",
      visible: (row) => true,
    },
  ];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MovimientosModal>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  filteredOptions: Observable<any[]>;
  matcher = new MyErrorStateMatcher();

  public ngOnInit() {
    this.list = this.data.list
      .map((m) => {
        return {
          Id: m.IdMaterial,
          Desc: (m.NoParteInterno ?? "") + " - " + (m.Descripcion ?? ""),
          NoParteInterno: parseInt(m.NoParteInterno.trim() ?? "0"),
        };
      })
      .sort(function (a, b) {
        return a.NoParteInterno - b.NoParteInterno;
      });
    this.buildForm();
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Entrada: ["", [Validators.required]],
      Razon: [""],
      NoFactura: [""],
      Material: new FormControl("", [Validators.required, RequireMatch]),
    });
    this.filteredOptions = this.form.controls["Material"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
    this.columns[3].visible = this.data.isEntry;
  }
  displayWith(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filter(value: any): string[] {
    if (value == null) return this.list;

    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();
    
    return this.list.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue)
    );
  }

  actionstable(e: { action: string; row: any }) {
    if (e.action == "delete") {
      var ttt = this.realData.filter(f  => f.rowId != e.row.rowId);
      this.realData = [...ttt];
      this.tableComp.setData(this.realData);
    }
  }
  add() {
    const dataForm = this.form.value;
    const rowId = new Date().getTime().toString(18);
    const data = { ...dataForm, Cant: this.form.value.Entrada, IdMaterial: dataForm.Material.Id,  MaterialDesc: dataForm.Material.Desc, rowId };
    this.realData = [...this.realData, data];
    this.tableComp.setData(this.realData);
    this.form.reset();
  }
  save() {
    const data = this.realData.map(m =>  {return {...m, Salida: m.Entrada}});
    this.dialogRef.close(data);
  }
}
